module.exports = __webpack_public_path__ + "static/media/slider-l3.71aaf905.webp";